
import {ComponentType, ReactElement} from 'react'
import {flowRight as compose} from 'lodash'
import {I18nContextValues, Trans, withNamespaces} from 'react-i18next'
import withStyles, {StyledComponentProps} from '@material-ui/core/styles/withStyles'
import {Grid, Typography} from '@material-ui/core'
import messages from '../../../../../../../assets/messages'
import NotificationBar from '../../../../../../Common/NotificationBar'
import {AlertDialog} from '../../../../../../Common/Dialog'
import {BrokereeCopyTradingOffer} from '../../../../types'
import {styles} from './styles'

type SubscribeAlertDialogPropsBase = {
  isOpen: boolean
  offer: BrokereeCopyTradingOffer | null
  errorMessage: string | null
  isLoading: boolean
  onAgree: () => void
  onDisagree: () => void
}

type SubscribeAlertDialogProps = SubscribeAlertDialogPropsBase & StyledComponentProps & I18nContextValues

const Component = (props: SubscribeAlertDialogProps): ReactElement => {
  const {classes = {}, t, offer, errorMessage, isOpen, isLoading, onAgree, onDisagree} = props

  const {performanceFee = 0} = offer ?? {}
  const willKeepBonus = offer?.provider.client.metadata.copyTradingKeepClientBonuses

  return (
    <AlertDialog
      open={isOpen}
      title={
        <Typography variant='body1' className={classes.alertTitle}>
          <Trans
            {...messages.requestCopyTradingTitle}
            components={[<span className={classes.highlight}>start copying</span>]}
          />
        </Typography>
      }
      agreeText={t(messages.startCopying.i18nKey, messages.startCopying.defaults)}
      disagreeText={t(messages.cancel.i18nKey, messages.cancel.defaults)}
      buttonLoading={isLoading}
      buttonStatus={errorMessage != null ? 'failure' : null}
      onAgree={onAgree}
      onDisagree={onDisagree}
      onClose={onDisagree}
    >
      <Grid container direction="row" alignContent="center" justifyContent="center" spacing={3}>
        <Grid item xs={12}>
          <Typography variant='body1'>
            <Trans {...messages.requestCopyTradingText} />
          </Typography>
        </Grid>
        {performanceFee > 0 ? (
          <Grid item xs={12}>
            <Typography variant='body1'>
              <Trans
                {...(willKeepBonus ? messages.requestCopyTradingTextWithBonusesKept2 : messages.requestCopyTradingText2)}
                values={{fee: performanceFee}}
                components={[<span className={classes.standardHighlight}> </span>]}
              />
            </Typography>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Typography variant='body1'>
              <Trans {...messages.requestCopyTradingNoPerformanceFeeText} />
            </Typography>
          </Grid>
        )}
      </Grid>
      {errorMessage != null ? <NotificationBar status="error">{errorMessage}</NotificationBar> : null}
    </AlertDialog>
  )
}

export const SubscribeAlertDialog: ComponentType<SubscribeAlertDialogPropsBase> = compose(
  withStyles(styles),
  withNamespaces(),
)(Component)
